import { useState } from 'react';
import { useEffectOnce } from './use_effect_once.ts';

let isAppActive = true;

const activeListeners: ((active: boolean) => void)[] = [];

export function useIsAppActive() {
  const [isActive, setIsActive] = useState(isAppActive);

  useEffectOnce(() => {
    const listener = (active: boolean) => setIsActive(active);
    addActiveListener(listener);
    return () => removeActiveListener(listener);
  });

  return isActive;
}

function addActiveListener(listener: (active: boolean) => void) {
  activeListeners.push(listener);
}

function removeActiveListener(listener: (active: boolean) => void) {
  const index = activeListeners.indexOf(listener);
  if (index !== -1) {
    activeListeners.splice(index, 1);
  }
}

// for code outside React that wants the same signal (the live-update socket, issue #3265)
export function subscribeAppActive(listener: (active: boolean) => void): () => void {
  addActiveListener(listener);
  return () => removeActiveListener(listener);
}

export function notifyActiveListeners(isActive: boolean) {
  if (isActive === isAppActive) {
    return;
  }
  isAppActive = isActive;
  for (const listener of activeListeners) {
    listener(isActive);
  }
}
